var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRectangleDock = function SvgRectangleDock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.306 21.746h17.387c2.1 0 3.155-1.044 3.155-3.114V6.367c0-2.069-1.055-3.113-3.154-3.113H3.305C1.217 3.254.152 4.289.152 6.367v12.266c0 2.079 1.065 3.113 3.154 3.113Zm.03-1.617c-1.004 0-1.566-.532-1.566-1.577V6.45c0-1.045.562-1.578 1.566-1.578h17.327c.995 0 1.567.533 1.567 1.578V18.55c0 1.045-.572 1.578-1.567 1.578H3.336Zm15.379-4.35c0-.531-.302-1.003-1.055-1.003H6.34c-.754 0-1.055.472-1.055 1.004v.372c0 .532.301 1.004 1.054 1.004H17.66c.753 0 1.055-.472 1.055-1.004v-.372Z",
    fill: "#FAFAFA",
    fillOpacity: 0.8
  })));
};
export default SvgRectangleDock;